export default "__VITE_ASSET__6$CR6xMu__"